// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3BW35","emails":"CreateEditClinics_emails__2rEpw","emailTagLabel":"CreateEditClinics_emailTagLabel__XaGWm"};